module.exports = __webpack_public_path__ + "static/assets/img/remote_work_room.bbb7bbd8.svg";